import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Phone, Mail, Linkedin, Youtube, Twitter } from "lucide-react";
import UMDLogo from "./UMDLogo";
import { SITE } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#08142b] text-white relative overflow-hidden">
      <div className="grid-bg absolute inset-0 opacity-50 pointer-events-none" />

      {/* Pre-footer CTA strip */}
      <div className="container-wide relative z-10 border-b border-white/10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="eyebrow eyebrow-light mb-6">Let's build</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight">
              Have a project that<br />
              demands <span className="text-[var(--primary)]">real engineering?</span>
            </h2>
          </div>
          <div className="md:col-span-4 flex flex-col gap-4">
            <Link to="/contact" data-testid="footer-cta-proposal" className="btn-primary justify-between">
              Request a proposal <ArrowUpRight size={18} className="arrow" />
            </Link>
            <a href={`tel:${SITE.phone}`} data-testid="footer-cta-call" className="btn-outline btn-outline-light justify-between">
              {SITE.phone} <Phone size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="container-wide relative z-10 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <UMDLogo light />
          <p className="mt-8 text-white/70 text-sm leading-relaxed max-w-sm">
            Australian engineering practice designing, manufacturing and deploying mission-critical IoT and edge systems since 1983.
          </p>
          <div className="flex items-center gap-3 mt-8">
            <a href={SITE.socials.linkedin} data-testid="social-linkedin" className="w-10 h-10 border border-white/20 hover:border-[var(--primary)] hover:text-[var(--primary)] flex items-center justify-center transition-colors"><Linkedin size={16}/></a>
            <a href={SITE.socials.youtube} data-testid="social-youtube" className="w-10 h-10 border border-white/20 hover:border-[var(--primary)] hover:text-[var(--primary)] flex items-center justify-center transition-colors"><Youtube size={16}/></a>
            <a href={SITE.socials.twitter} data-testid="social-twitter" className="w-10 h-10 border border-white/20 hover:border-[var(--primary)] hover:text-[var(--primary)] flex items-center justify-center transition-colors"><Twitter size={16}/></a>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/40 font-mono-tech mb-5">Company</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-[var(--primary)] transition-colors">About</Link></li>
            <li><Link to="/team" className="hover:text-[var(--primary)] transition-colors">Team</Link></li>
            <li><Link to="/case-studies" className="hover:text-[var(--primary)] transition-colors">Case studies</Link></li>
            <li><Link to="/insights" className="hover:text-[var(--primary)] transition-colors">Insights</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--primary)] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/40 font-mono-tech mb-5">Services</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services/engineering-iot" className="hover:text-[var(--primary)] transition-colors">Engineering & IoT</Link></li>
            <li><Link to="/services/project-management" className="hover:text-[var(--primary)] transition-colors">Project Management</Link></li>
            <li><Link to="/services/system-integration" className="hover:text-[var(--primary)] transition-colors">System Integration</Link></li>
            <li><Link to="/services/manufacturing" className="hover:text-[var(--primary)] transition-colors">Manufacturing</Link></li>
            <li><Link to="/services/asset-management" className="hover:text-[var(--primary)] transition-colors">Asset Management</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[11px] tracking-[0.2em] uppercase text-white/40 font-mono-tech mb-5">Headquarters</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex gap-3"><MapPin size={16} className="mt-0.5 text-[var(--primary)] shrink-0"/>{SITE.address}</li>
            <li className="flex gap-3"><Phone size={16} className="mt-0.5 text-[var(--primary)] shrink-0"/><a href={`tel:${SITE.phone}`} className="hover:text-white">{SITE.phone}</a></li>
            <li className="flex gap-3"><Mail size={16} className="mt-0.5 text-[var(--primary)] shrink-0"/><a href={`mailto:${SITE.email}`} className="hover:text-white">{SITE.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="container-wide relative z-10 py-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-white/40 font-mono-tech tracking-wider uppercase">
        <div>© 2026 Unique Micro Design Pty Ltd · {SITE.abn}</div>
        <div className="flex gap-6">
          <a href="#" className="hover:text-white">Privacy</a>
          <a href="#" className="hover:text-white">Terms</a>
          <a href="#" className="hover:text-white">ISO 9001 · ISO 27001</a>
        </div>
      </div>
    </footer>
  );
}
